import { render, staticRenderFns } from "./TermsConditionsReferral.vue?vue&type=template&id=f45b1482&scoped=true&"
import script from "./TermsConditionsReferral.vue?vue&type=script&lang=js&"
export * from "./TermsConditionsReferral.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditionsReferral.vue?vue&type=style&index=0&id=f45b1482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45b1482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
